<template >
  <div
    class="container-fluid"
    style="margin-top: 40px"
    v-if="lesson"
    :key="componentKey"
  >
    <div class="row justify-content-center px-5 py-5">
      <div class="col">
        <div class="text-center">
          <ul class="menutabs">
            <li
              class="tabli"
              v-if="allGroups == false"
              v-for="(group, gindex) in groups"
              v-bind:class="tab_selected == gindex ? 'bottom-bordered' : ''"
              @click="_showStudents(group, gindex)"
              :key="gindex"
            >
              <h3
                class="tabText"
                style="text-decoration: none"
                v-if="group.isGroup && group.isGroup == true"
              >
                {{ _getGroupName(group) }} - {{ group.loaded }}
              </h3>
              <h3
                class="tabText text-uppercase"
                style="text-decoration: none"
                v-else
              >
                <span
                  >{{ group.departmentName }}/{{ group.programName }}
                  <span class="op">({{ group.students.length }})</span></span
                >
              </h3>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="row justify-content-between"></div>

    <div class="card mb-4" v-if="lesson.groups && lesson.groups.length > 0">
      <div class="card-header py-3">
        <div class="d-flex justify-content-between align-items-center">
          <span class="text-danger" style="font-size: 8pt"
            >{{ actionstatus }} {{ _getCurrentDate() }}
            {{ lesson.groups.length }}</span
          >
          <button
            class="btn btn-sm btn-danger"
            @click="handleDownload"
            v-if="!loading"
          >
            Export
          </button>
        </div>
      </div>
      <div class="card-body">
        <div style="overflow-x: scroll">
          <table class="table table-bordered table-sm score-table">
            <thead>
              <tr>
                <th class="sticky-col first-col" style="width: 1%!important"></th>
                <th
                  class="sticky-col second-col text-primary"
                  style="width: 5%"
                >
                  Сурагч
                </th>
                <th
                  class=""
                  style="cursor: pointer; width: 4%"
                  v-for="(assi, index) in assignments" :key="index"
                >
                  <span class="text-primary scorehead" @click="_editScore(assi)"
                    >{{ getXXSubStr(assi.name, 4) }}
                  </span>
                  <!-- <small v-if="assi.assignmentScores" class="text-secondary"
                    >{{ assi.createdAt | formatDate}}</small
                  > -->
                  <!-- <span class="float-right"><i @click="_clearScoreColumn(topic,index)"  class="text-danger fas fa-times"></i></span>) -->
                </th>
                <th class="text-primary scorehead">
                  <span
                    >Нийлбэр
                    <span class="float-right"
                      ><i
                        @click="_setFinal(2)"
                        class="text-danger fas fa-arrow-right"
                        style="cursor: pointer"
                      ></i></span
                  ></span>
                </th>
                <th class="text-primary scorehead">
                  Эцсийн дүн<span class="float-right"
                    ><i
                      @click="_clearFinalScore()"
                      class="text-danger fas fa-times"
                      style="cursor: pointer"
                    ></i
                  ></span>
                </th>
              </tr>
            </thead>
            <tbody v-for="(group, gindex) in groups" v-if="allGroups" :key="gindex">
              <tr
                v-if="allGroups == true && group.students.length > 0"
                style="background-color: #f1f1f1"
              >
                <td
                  colspan="10"
                  class="text-primary"
                  style="text-transform: uppercase"
                  v-if="group.isGroup && group.isGroup == true"
                >
                  {{ gindex + 1 }}.{{ group.groupName }}xxx
                </td>
                <td
                  colspan="10"
                  class="text-primary"
                  style="text-transform: uppercase"
                  v-else
                >
                  <span>
                    {{ group.departmentName }}/{{ group.programName }}</span
                  >
                </td>
              </tr>
              <tr v-for="(student, sindex) in group.students" :key="sindex">
                <td>{{ sindex + 1 }}</td>
                <td @click="_detailOfstudent(student)">
                  <span v-if="student.lastname && student.lastname.length > 0">
                    <span
                      v-if="
                        student.lncount &&
                        student.lncount > 1 &&
                        student.lastname.length >= student.lncount
                      "
                      >{{
                        student.lastname.substring(0, student.lncount)
                      }}</span
                    >
                    <span v-else>{{ student.lastname[0] }}</span
                    >.
                  </span>
                  {{ student.name }}
                </td>
                <td v-for="(scoredata, sindex) in student.topics" :key="sindex">
                  <!-- {{scoredata}} -->
                  <div v-if="scoredata && scoredata.data">
                    <div class="">
                      <div class="">
                        <span
                          v-bind:class="[
                            scoredata.data.earnedScore &&
                            scoredata.data.earnedScore > 50
                              ? 'bg-success-light'
                              : 'bg-danger-light',
                          ]"
                          class="input-sm form-control alignLeft"
                          placeholder="Оноо оруулаагүй!"
                          type="number"
                          @change="scoreChanged(student, scoredata)"
                        >
                          xxx</span
                        >
                      </div>
                    </div>
                  </div>
                </td>
                <!-- <td>
                	{{_getAvg(student.topics)}}
              	</td> -->
                <td class="alignRight font-weight-bold align-items-center">
                  <!-- {{_getSum(student.topics)}} -->
                  {{ student["calculatedScore"] }}
                </td>
                <td>
                  <input
                    class="form-control input-sm alignRight"
                    type="number"
                    v-model="student.earnedScore"
                    @change="finalScoreChanged(student)"
                  />
                </td>
              </tr>
            </tbody>
            <tbody v-if="allGroups == false">
              <tr
                v-for="(student, sindex) in currentSelectedGroup.students"
                :key="sindex"
              >
                <td class="text-secondary sticky-col first-col" style="width:1%!important">
                  {{ sindex + 1 }}
                </td>
                <td class="sticky-col second-col">
                  <span v-if="student.lastname && student.lastname.length > 0">
                    <span
                      v-if="
                        student.lncount &&
                        student.lncount > 1 &&
                        student.lastname.length >= student.lncount
                      "
                      >{{
                        student.lastname.substring(0, student.lncount)
                      }}</span
                    >
                    <span v-else>{{ student.lastname[0] }}</span
                    >.
                  </span>
                  <span
                    style="cursor: pointer"
                    @click="_detailOfstudent(student)"
                    >{{ student.name }}
                  </span>
                  <!-- <p style="font-size:8pt">{{student.ref.path}}</p> -->
                </td>
                <td v-for="assignment in assignments">
                  <!-- {{scoredata}} -->
                  <!-- <div v-if="scoredata && scoredata.data" > -->
                  <div>
                    <div class="">
                      <div v-if="_getAssignmentScore(student, assignment) > 0">
                        <!-- v-bind:class="[60>50? 'bg-success-light' : 'bg-danger-light']"  -->
                        <span
                          placeholder="Оноо оруулаагүй!"
                          :title="assignment.name"
                        >
                          <!-- {{_getAssignmentScore(student,assignment)}} -->
                          {{ student.earnedScore }}
                        </span>
                      </div>
                    </div>
                  </div>
                </td>
                <td
                  style="cursor: pointer"
                  class="
                    tablecell
                    alignRight
                    font-weight-bold
                    align-items-center
                  "
                  :title="student.name"
                >
                  <!-- {{_getSum(student.topics)}} -->
                  <!-- {{ student["calculatedScore"] }} -->
                  {{ _calculateFinalScore(student) }}
                </td>
                <td>
                  <!-- <input class="form-control input-sm alignRight" type="number" v-model="student.finalScore" @change="finalScoreChanged(student)"/> -->
                  <!-- {{ _getFinalAssignmentScore(student) }} -->
                  <!-- <button @click="_getFinalAssignmentScore(student)">
                    click
                  </button> -->
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div v-else class="alert alert-warning text-center mb-4">
      <h4>Та одоогоор ямар нэгэн сэдэв оруулаагүй байна.</h4>
    </div>
    <div
      v-if="loading == true"
      style="position: fixed; z-index: 10000000; top: 45%; left: 45%"
    >
      <div class="spinner-grow text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-secondary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-success" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-danger" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-warning" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-info" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-dark" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
</template>

<script>
const fb = require("../../../firebaseConfig.js");
import { mapState } from "vuex";
import moment, { max } from "moment";
import firebase from "firebase";
import VueQrcode from "vue-qrcode";
import LessonInfo from "../shared/LessonInfo";
import myfunction from "../../global/myfunction.js";
export default {
  name: "ILessonScores",

  data() {
    return {
      loading: false,
      assignments: [],
      componentKey: 0,
      currentSelectedGroup: null,
      allGroups: false,
      tab_selected: 0,
      actionstatus: null,
      lesson: null,
      topic: null,
      content: { name: null, totalScore: 100, totalProcent: null },
      topics: null,
      types: [],
      selectedType: null,
      studentsText: "",
      selectedTopic: null,
      tmpStudents: [],

      display: 0,
      tagText: null,
      dayStr: null,
      selectedCell: null,
      selectedTopicIndex: null,
      selectedGroupIndex: null,
      schools: [],
      teachers: [],

      school: null,
      department: null,
      program: null,

      teacher: null,
      groups: [],
      currentSelectedStudent: null,
      savingFinalGrades: false,
    };
  },
  mixins: [myfunction],
  methods: {
    async _showStudents(group, index) {
      this.currentSelectedGroup = group;
      this.tab_selected = index;
      //if(group.loaded==false)
      await this.getStudentsFromGroup(this.currentSelectedGroup);
      //this._initData();
    },

    _getCurrentDate() {
      var val = new Date();
      return moment(val).format("MM.DD | HH:mm");
      // if (!val) { return '-' }
      // let date = val.toDate()
      // return moment(date).format('MM/DD/YYYY HH:mm');
    },

    async _clearFinalScore() {
      var yes = confirm("Та эцсийн бүx дүнгүүдийг устгаxыг xүсэж байна уу?");

      if (yes) {
        var doc = await fb.db
          .collection("schools/" + this.schoolId + "/lessons")
          .doc(this.lessonId)
          .collection("studentList")
          .get()
          .then(function (studentList) {
            studentList.forEach(function (student) {
              student.ref.update({
                finalScore: null,
                scoreModifiedAt: new Date(),
              });
            });
          });
        this._initData();
      }
    },

    _clearData() {
      var yes = confirm("Та бүx оноонуудыг арилгаxыг xүсэж байна уу?");
      if (yes) {
        if (this.allGroups) {
          for (var group of this.groups) {
            for (const student of group.students) {
              for (const dta of student.topics) {
                fb.db
                  .collection(dta.topic.ref.path + "/sstudents")
                  .get()
                  .then(function (querySnapshot) {
                    if (querySnapshot && !querySnapshot.empty) {
                      querySnapshot.forEach(function (doc) {
                        // doc.data() is never undefined for query doc snapshots
                        //console.log();
                        doc.ref.update({ earnedScore: 0, procent: 0 });
                        // doc.ref.delete();
                      });
                    }
                  });
              }
            }
          }
        } else {
          if (this.currentSelectedGroup != null) {
            for (const student of this.currentSelectedGroup.students) {
              for (const dta of student.topics) {
                fb.db
                  .collection(dta.topic.ref.path + "/sstudents")
                  .get()
                  .then(function (querySnapshot) {
                    if (querySnapshot && !querySnapshot.empty) {
                      querySnapshot.forEach(function (doc) {
                        if (student.id == doc.id)
                          doc.ref.update({ earnedScore: 0, procent: 0 });
                      });
                    }
                  });
              }
            }
          }
        }
        this.actionstatus = "Бүx дүнг арилгасан";
        this.getStudents(this.currentSelectedGroup);
      }
      //TODO selected tab deer uldej baigaa bolovch 8a garch ireed baina
    },
    _deleteColumnHeads() {
      var yes = confirm("Та бүx оноонуудын баганыг устгаxыг xүсэж байна уу?");
      if (yes) {
        for (var group of this.groups) {
          for (const student of group.students) {
            for (const dta of student.topics) {
              fb.db
                .collection(dta.topic.ref.path + "/sstudents")
                .get()
                .then(function (querySnapshot) {
                  if (querySnapshot && !querySnapshot.empty) {
                    querySnapshot.forEach(function (doc) {
                      doc.ref.delete();
                    });
                  }
                });
            }
          }
        }
        for (var topic of this.topics) {
          topic.ref.delete();
        }
        fb.db
          .doc("schools/" + this.schoolId + "/lessons/" + this.lessonId)
          .update({
            numberOfYvts: 0,
          });
        this._initData();
      }
    },

    _detailOfstudent(student) {
      for (var sc of student.scores) {
        console.log(sc.id, sc.earnedScore);
      }
      // this.currentSelectedStudent = student;
      // $("#studentInfo").modal("toggle");
    },
    _splitName(name) {
      if (name && name.includes("/")) {
        var n = name.indexOf("/");
        return name
          .substring(n, name.length)
          .replaceAll("/", "")
          .replaceAll("-", "/");
      }
      return name;
    },
    _getGroupName(group) {
      if (group.isGroup) {
        return this._splitName(group.groupName);
      } else return group.groupName;
    },
    async _initData() {
      this.loading = true;
      var doc = await fb.db
        .collection("schools/" + this.schoolId + "/lessons")
        .doc(this.lessonId)
        .get();
      let lesson = doc.data();
      lesson.id = doc.id;
      this.lesson = lesson;

      this.groups = [];
      if (this.programId && this.programId != "") {
        for (const group of this.lesson.groups) {
          console.log(group);
          if (group && group.program && group.program.id == this.programId) {
            var grp = Object.assign({}, group);
            grp.students = [];
            grp.count = 0;
            this.groups.push(grp);
          }
        }
      } else if (this.groupId && this.groupId != "") {
        for (const group of this.lesson.lessonGroups) {
          console.log("group");
          if (group && group.group && group.group.id == this.groupId) {
            var grp = Object.assign({}, group);
            grp.students = [];
            grp.count = 0;
            grp.isGroup = true;
            this.groups.push(grp);
          }
        }
      }
      // group uusgej huuhed songodog groupuud
      else {
        if (
          this.lesson.isGroup != null &&
          this.lesson.isGroup != undefined &&
          this.lesson.isGroup == true
        ) {
          for (const group of this.lesson.lessonGroups) {
            console.log(group);
            var grp = Object.assign({}, group);
            grp.students = [];
            grp.count = 0;
            grp.isGroup = true;
            this.groups.push(grp);
          }
        } else
          for (const group of this.lesson.groups) {
            var grp = Object.assign({}, group);
            grp.students = [];
            grp.count = 0;
            this.groups.push(grp);
          }
      }
      if (this.groups.length > 0 && this.currentSelectedGroup == null) {
        this.currentSelectedGroup = this.groups[0];
        //this._isFinalGradeMade(this.currentSelectedGroup);
      }
      this.loading = false;
      await this.findAssignments();
      await this.getStudents();
    },

    async _getStudentFrom(studentsSnapshot, students) {
      for (const doc of studentsSnapshot.docs) {
        let student = doc.data();
        student.id = doc.id;
        student.ref = doc.ref;
        student.topics = [];
        student.finalScore = null;
        students.push(student);
      }
    },
    async getStudentsFromGroup(group) {
      console.log(this.school,group)
      var studentsSnapshot;
      if (group.isGroup && group.isGroup == true) {
        studentsSnapshot = await fb.db
          .collection("schools/" + this.schoolId + "/students")
          .where("lessonGroups", "array-contains", group.group)
          .orderBy("name", "asc")
          .get();
      } else {
        studentsSnapshot = await fb.db
          .collection("schools/" + this.schoolId + "/students")
          .where("program-"+this.school.currentYear, "==", group.program)
          .orderBy("name", "asc")
          .get();
      }

      if (studentsSnapshot && !studentsSnapshot.empty) {
        //group.students = [];
        await this._getStudentFrom(studentsSnapshot, group.students);
        group.loaded = true;
      }
    },
    async getStudents() {
      if (
        this.lesson != null &&
        this.lesson != undefined &&
        this.lesson.groups &&
        this.lesson.groups.length > 0
      ) {
        if (this.allGroups) {
          for (const group of this.groups) {
            this.getStudentsFromGroup(group);
          }
        } else {
          this.getStudentsFromGroup(this.currentSelectedGroup);
        }
      }
    },

    async findAssignments() {
      //   /schools/xUSN7smB3EcLwDYhs1Y9/lessons/PpcpD0txD1gDKRVHt1tV/topics/OZqBb363A5pRAwBvLzj4/details/LyubmCzhCDsqshxElYGI/sstudents
      if (
        this.lesson != null &&
        this.lesson != undefined &&
        this.lesson.groups &&
        this.lesson.groups.length > 0 &&
        this.topics == null
      ) {
        var topicSnapshot = await fb.db
          .collection("schools/" + this.schoolId + "/lessons")
          .doc(this.lesson.id)
          .collection("topics")
          .orderBy("createdAt", "desc")
          .get();
        if (topicSnapshot && !topicSnapshot.empty) {
          this.topics = [];
          for (const doc of topicSnapshot.docs) {
            let topic = doc.data();
            topic.id = doc.id;
            topic.contents = [];
            topic.ref = doc.ref;

            fb.db
              .collection(topic.ref.path + "/details")
              .orderBy("createdAt", "desc")
              .get()
              .then((xdoc) => {
                xdoc.forEach(async (content) => {
                  let assignment = content.data();
                  assignment.ref = content.ref;
                  assignment.id = content.id;
                  if ((assignment.type = "assignment")) {
                    assignment.assignmentScores = [];
                    fb.db
                      .doc(assignment.ref.path)
                      .collection("sstudents")
                      .get()
                      .then((docs) => {
                        docs.forEach((ssdudDoc) => {
                          let sstud = ssdudDoc.data();
                          sstud.ref = ssdudDoc.ref;
                          sstud.id = ssdudDoc.id;
                          assignment.assignmentScores.push(sstud);
                        });
                      });
                    console.log(assignment.createdAt.toString());
                    this.assignments.push(assignment);
                  }
                });
              });
            this.topics.push(topic);
          }
        }
      }
    },
    _isSavedAssignmentScore(student, stud, assignment) {
      for (var st of student.scores) {
        if (st.assignmentId == assignment.id) return true;
      }
      return false;
    },
    _calculateFinalScore(student) {
      var finalScore = 0;
      if (student.scores != undefined) {
        for (var scoreData of student.scores) {
          finalScore = finalScore + scoreData.score;
        }
      }
      if (finalScore > 0) return finalScore.toFixed(2);
      else return null;
    },
    _getAssignmentScore(student, assignment) {
      if (assignment && assignment.assignmentScores) {
        for (var stud of assignment.assignmentScores) {
          if (student.id == stud.id) {
            if (stud.earnedScore && stud.earnedScore != null) {
              student.earnedScore = stud.earnedScore;

              if (student.scores == undefined) student.scores = [];

              if (
                this._isSavedAssignmentScore(student, stud, assignment) == false
              )
                student.scores.push({
                  assignmentId: assignment.id,
                  score: stud.earnedScore,
                });
              return stud.earnedScore;
            } else return -1;
          }
        }
      }
      return 0;
    },
    _getFinalAssignmentScore(student) {
      var summe = 0;
      for (var assi of this.assignments) {
        for (var stud of assi.assignmentScores) {
          if (student.id == stud.id) {
            summe = summe + student.earnedScore;
          }
        }
      }
      return summe;
    },

    findStudents(sc, dep, pro) {
      fb.db
        .collection("schools/" + this.schoolId + "/students")
        .where("school", "==", sc)
        .where("department", "==", dep)
        .where("program", "==", pro)
        .get()
        .then((docs) => {
          for (const studentData of docs.docs) {
            if (studentData != null && studentData.exists) {
              var studentDetail = studentData.data();
              this.addStudentToLesson(
                fb.db
                  .collection("schools/" + this.schoolId + "/lessons")
                  .doc(this.lesson.id),
                studentData,
                studentDetail
              );
            }
          }
        });
    },

    async scoreChanged(student, score) {
      if (
        student &&
        student.id &&
        score &&
        score.topic &&
        score.topic.id &&
        score.data &&
        score.data.earnedScore
      ) {
        student.calculatedScore = 0;
        var maxScore = 100;
        if (score.topic && score.topic.totalScore) {
          maxScore = score.topic.totalScore;
        }
        if (score.data.earnedScore > maxScore) {
          alert("Дээд онооноос хэтэрсэн байна.");
          fb.db
            .collection("schools/" + this.schoolId + "/lessons")
            .doc(this.lessonId)
            .collection("scores")
            .doc(score.topic.id)
            .collection("sstudents")
            .doc(student.id)
            .set(
              {
                modifiedAt: new Date(),
              },
              { merge: true }
            );
          return;
        }
        var procent = null;
        if (maxScore) {
          procent = (score.data.earnedScore * 100) / maxScore;
        }
        var createdDate = new Date();
        fb.db
          .collection("schools/" + this.schoolId + "/lessons")
          .doc(this.lessonId)
          .collection("scores")
          .doc(score.topic.id)
          .collection("sstudents")
          .doc(student.id)
          .set(
            {
              modifiedAt: createdDate,
              earnedScore: score.data.earnedScore,
              procent: procent,
            },
            { merge: true }
          );

        this.actionstatus =
          student.name + ", " + score.data.earnedScore + " дүн оруулсан: ";

        var summe = 0;
        for (const changedScore of student.topics) {
          var tmp =
            (changedScore.data.earnedScore * changedScore.topic.totalProcent) /
            100;
          summe += tmp;
        }
        student.calculatedScore = Math.round(summe).toFixed(2) * 1;
      }
    },
    async finalScoreChanged(student) {
      if (student && student.id && student.finalScore) {
        var studentDoc = await fb.db
          .collection("schools/" + this.schoolId + "/lessons")
          .doc(this.lessonId)
          .collection("studentList")
          .doc(student.id)
          .get();
        var createdDate = new Date();
        if (studentDoc.exists) {
          studentDoc.ref
            .update({
              scoreModifiedAt: createdDate,
              finalScore: student.finalScore,
              // procent: procent
            })
            .then(async (xx) => {
              await fb.db
                .collection("schools/" + this.schoolId + "/students")
                .doc(student.id)
                .collection("finalGrades")
                .doc(this.lessonId)
                .set({
                  createdAt: new Date(),
                  finalScore: student.finalScore,
                  semester: "2020-II",
                });
              this.actionstatus =
                student.name + ", " + student.finalScore + " дүн оруулсан: ";
            });

          //TODOxx
        } else {
          studentDoc.ref.set({
            scoreModifiedAt: new Date(),
            finalScore: student.finalScore,
            addedDate: createdDate,
            studentRef: student && student.ref ? student.ref : null,
            // addedUser:
            // procent: procent
          });
          this.actionstatus =
            student.name + ", " + student.finalScore + " дүн оруулсан: ";
        }
      }
    },
    _getTableHeader() {
      var header = [1];
      for (var assi of this.assignments) {
        header.push(assi.name);
      }
      return header;
    },
    _getTableBody() {
      var bodyData = [];
      for (var i = 0; i < this.students.length; i++) {
        var row = [];
        row.push(this.students[i].name);

        for (var lesson of this.lessonCategoriesInvolvedListData) {
          //row.push(this._getCategoryScore(lesson,student,true));
          var x = this._getCategoryScore(lesson, this.students[i], true);
          if (x == -2) row.push(null);
          else row.push(x);
        }

        for (var xScore of this._calStudentLevels(this.students[i], i)) {
          row.push(xScore);
        }
        bodyData.push(row);
      }
      return bodyData;
    },
    handleDownload() {
      //this.downloadLoading = true
      import("@/vendor/Export2Excel").then((excel) => {
        const tHeader = this._getTableHeader();
        const data = []; //this._getTableBody();
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: "_daalgavar",
          autoWidth: true,
          bookType: this.bookType,
        });
        //this.downloadLoading = false
      });
    },
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
  components: {
    VueQrcode,
    LessonInfo,
  },
  props: {
    schoolId: {
      required: true,
    },
    lessonId: {
      required: true,
    },
    programId: {
      required: false,
    },
    groupId: {
      required: false,
    },
  },
  created() {
    // /schools/xUSN7smB3EcLwDYhs1Y9/departments/6xvVvEq1CzxW7vUx8Nnl/programs/xz0KhaYquJpyjT8oJL4h

    fb.db
      .collection("schools")
      .doc(this.schoolId)
      .onSnapshot((doc) => {
        let school = doc.data();
        school.id = doc.id;
        this.school = school;
      });

    if (this.lessonId != null && this.lessonId != "") {
      this._initData();
    }
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).format("MM/DD/YYYY HH:mm");
    },
  },
};
</script>


<style>
.sticky-col {
  position: -webkit-sticky;
  position: sticky;
  background-color: #f9f9f9;
}

.first-col {
  /* width: 100px;
  min-width: 100px;
  max-width: 100px;
  left: 0px; */
}

.second-col {
  /* width: 150px;
  min-width: 150px;
  max-width: 150px;
  left: 100px; */
}

::placeholder {
  color: #bbb !important;
  font-size: 10pt;
}
.scorehead {
  width: 12%;
}
.score-table.form-control {
  height: calc(1.8em) !important;
  border-radius: 0rem;
}
.score-table {
  width: 100%;
  margin-bottom: 1rem;
  color: #000;
}
.alignRight {
  text-align: right;
}
.alignLeft {
  text-align: left;
}
.table td,
.table th {
  vertical-align: middle;
  border-top: 1px solid #e3e6f0;
}
.b3-collapsing-form-additional-icons {
  display: inline-block;
  height: 24px;
  margin-bottom: -12px;
  margin-top: -12px;
  padding: 12px;
}
.svg-icon {
  cursor: pointer;
  display: inline-block;
  fill: #80868b;
  /* rgba(0,0,0,0.38);  */
  -webkit-transition: fill 0.25s linear;
  transition: fill 0.25s linear;
  width: 24px;
}
.svg-icon:hover {
  fill: rgba(0, 0, 0, 0.78);
}
</style>
